// Single source of truth for the AI model catalog shown in the UI.
// Version numbers drive provider routing in src/ai/api/index.js
// (< 10 = OpenAI, < 15 = Gemini, >= 15 = Claude).
export const AI_MODELS = [
  { name: 'OpenAI GPT-5.6 Luna', version: 5 },
  { name: 'OpenAI GPT-5.6 Terra', version: 6 },
  { name: 'OpenAI GPT-5.6 Sol', version: 7 },
  { name: 'Gemini 3.5 Flash', version: 11 },
  { name: 'Gemini 3.1 Pro', version: 12 },
  { name: 'Claude Sonnet 5', version: 15 },
  { name: 'Claude Opus 5', version: 16 },
  { name: 'Claude Fable 5', version: 17 },
  { name: 'Claude Haiku 4.5', version: 18 }
]

// Map a raw model id (as stored on usage rows, e.g. a Bedrock inference-profile id
// like 'global.anthropic.claude-sonnet-5', or a provider id like 'gemini-3.1-pro-preview')
// to the friendly catalog name shown in the model dropdown. Usage charts group by the
// raw id, which is long, provider/region-prefixed, and clips in narrow labels. Unknown
// ids fall back to the id with any provider/region prefix stripped.
const MODEL_LABEL_RULES = [
  { match: /claude.*sonnet.*5/i, name: 'Claude Sonnet 5' },
  { match: /claude.*opus.*5/i, name: 'Claude Opus 5' },
  { match: /claude.*fable.*5/i, name: 'Claude Fable 5' },
  { match: /claude.*haiku.*4.?5/i, name: 'Claude Haiku 4.5' },
  { match: /gemini.*3\.?5.*flash/i, name: 'Gemini 3.5 Flash' },
  { match: /gemini.*3\.?1.*pro/i, name: 'Gemini 3.1 Pro' },
  { match: /gpt.*5\.?6.*luna/i, name: 'OpenAI GPT-5.6 Luna' },
  { match: /gpt.*5\.?6.*terra/i, name: 'OpenAI GPT-5.6 Terra' },
  { match: /gpt.*5\.?6.*sol/i, name: 'OpenAI GPT-5.6 Sol' }
]

export const modelDisplayName = (rawId) => {
  if (!rawId) {
    return 'Unknown'
  }
  const hit = MODEL_LABEL_RULES.find((rule) => rule.match.test(rawId))
  if (hit) {
    return hit.name
  }

  // Unknown model — strip a leading provider/region prefix so it at least reads cleanly.
  return String(rawId).replace(/^(eu|us|apac)\.anthropic\./i, '').replace(/^anthropic\./i, '')
}
